<div class="container pt-5">
    <form (submit)="search(query)" class="row mb-3">
        <div class="col-md-8">
            <input  type="text" class="form-control" id="query" name="query"
                    [(ngModel)]="query" 
                    placeholder="first name, last name, email, team id, user id">
        </div>
        <div class="col-md-4">
            <button type="submit" class="btn btn-primary">Search</button>
        </div>
    </form>

    <div class="btn-group mb-3" role="group">
        <button class="btn btn-default" (click)="search('trialing')" type="button">Trialing</button>
        <button class="btn btn-default" (click)="search('trialing_to_comment')" type="button">Trialing - to comment</button>
        <button class="btn btn-default" (click)="search('trial_ended')" type="button">Trial ended</button>
        <button class="btn btn-default" (click)="search('yearly_ending_next_month')" type="button">Yearly ending next month</button>
        <button class="btn btn-default" (click)="search('yearly_overdue')" type="button">Yearly overdue</button>
        <button class="btn btn-default" (click)="search('yearly_users_limit')" type="button">Yearly over users limit</button>
        <button class="btn btn-default" (click)="search('free_plans')" type="button">Free plans</button>
        <button class="btn btn-default" (click)="search('partially_disabled_teams')" type="button">Teams that should be
            disabled
        </button>

        <button class="btn btn-secondary dropdown-toggle" type="button"
                [matMenuTriggerFor]="ABmenu">
            Teams under A/B test
        </button>
        <mat-menu #ABmenu="matMenu" xPosition="before">
            <ul class="p-0 m-0">
                @for (feature of featureToggles; track feature) {  
                <li mat-menu-item class="px-2">
                    <a class="dropdown-item" (click)="search('abtest=' + feature.feature)">{{feature.feature}}</a>
                </li>
                }
            </ul>
        </mat-menu>
    </div>

    <div>
        @for (team of teams; track team) {
            <admin-team-settings [team]="team" [features]="features" (onChange)="reload()"></admin-team-settings>
        }
    </div>

    <div>
        @for (team_member of team_members; track team_member) {
            <admin-team-member-settings [teamMember]="team_member" (onChange)="reload()"></admin-team-member-settings>
        }
    </div>
</div>